<template>
  <div>
    <v-card class="rounded-lg white">
      <v-card-title class="secondary--text">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn 
          color="primary" 
          @click="showSurveyFilters = !showSurveyFilters"
          small
        >
          فیلترهای نظرسنجی
        </v-btn>
      </v-card-title>
      
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field 
              label="نام کاربری" 
              v-model="filters.username__startswith" 
              class="rounded-lg" 
              clearable
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field 
              label="نام" 
              v-model="filters.first_name__icontains" 
              class="rounded-lg" 
              clearable
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field 
              label="نام خانوادگی" 
              v-model="filters.last_name__icontains" 
              class="rounded-lg" 
              clearable
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field 
              label="شماره تلفن" 
              v-model="filters.phone__icontains" 
              class="rounded-lg" 
              clearable
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-expand-transition>
          <div v-if="showSurveyFilters" class="survey-filters-container">
            <v-divider class="my-4"></v-divider>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedSurveyFilters.survey_team_size"
                  :items="teamSizeOptions"
                  label="تیم شما چند نفره است؟"
                  clearable
                  outlined
                  dense
                  multiple
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedSurveyFilters.survey_accounting_familiarity"
                  :items="accountingFamiliarityOptions"
                  label="با حسابداری چقدر آشنایی دارید؟"
                  clearable
                  outlined
                  dense
                  multiple
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedSurveyFilters.survey_registration_goal"
                  :items="registrationGoalOptions"
                  label="هدف شما از ثبت‌نام در نرم‌افزار چیست؟"
                  clearable
                  outlined
                  dense
                  multiple
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedSurveyFilters.survey_features_used"
                  :items="featuresUsedOptions"
                  label="از کدام ویژگی های سبحان بیشترین استفاده را دارید؟"
                  clearable
                  outlined
                  dense
                  multiple
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedSurveyFilters.survey_current_accounting"
                  :items="currentAccountingOptions"
                  label="در حال حاضر حسابداری کسب و کار خود را چگونه انجام میدهید؟"
                  clearable
                  outlined
                  dense
                  multiple
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedSurveyFilters.survey_challenges"
                  :items="challengesOptions"
                  label="بزرگ‌ترین چالش‌های فعلی شما کدام هستند؟"
                  clearable
                  outlined
                  dense
                  multiple
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <div class="d-flex justify-end">
                  <v-btn 
                    text 
                    color="error" 
                    @click="clearSurveyFilters"
                    class="ml-2"
                  >
                    پاک کردن فیلترها
                  </v-btn>
                  <v-btn 
                    color="primary" 
                    @click="applySurveyFilters"
                  >
                    اعمال فیلترها
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>

        <m-datatable
          :headers="headers"
          :apiUrl="url"
          :filters="activeFilters"
          @dblclick:row="(e, row) => handleRowClick(row.item)"
          ref="datatable"
          :key="datatableKey"
        >
          <template #item.survey="{ item }">
            <v-row v-if="item.survey" no-gutters class="text-right">
              <v-col v-for="i in item.survey" cols="12">
                {{ i.question }}
                <span v-if="Array.isArray(i.answer)">{{ i.answer.join(", ") }}</span>
                <span v-else>{{ i.answer }}</span>
              </v-col>
            </v-row>
          </template>
          <template #item.actions="{ item }">
            <v-menu offset-y left>
              <template #activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on">
                  <v-icon>fa-ellipsis-v</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="openDiscountDialog(item)">
                  <v-list-item-icon>
                    <v-icon small color="success">fa-ticket-alt</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>ارسال کد تخفیف</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openCreateCompanyDialog(item)">
                  <v-list-item-icon>
                    <v-icon small color="primary">fa-building</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>ساخت کسب‌وکار</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" :overlay="true" transition="dialog-transition">
      <user-detail v-if="userId" :id="userId" />
    </v-dialog>
    <v-dialog v-model="discountDialog" max-width="500">
      <v-card>
        <v-card-title>
          ارسال کد تخفیف
        </v-card-title>

        <v-card-text>
          <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="نام کامل"
                  v-model="selectedUser.fullname"
                  disabled
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="شماره تلفن"
                  v-model="selectedUser.phone"
                  disabled
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="درصد تخفیف"
                  v-model="discountForm.price_percent"
                  type="number"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="کد تخفیف"
                  v-model="discountForm.discount_code"
                  outlined
                  dense
                />
              </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="discountDialog = false">
            انصراف
          </v-btn>

          <v-btn
            color="primary"
            @click="sendDiscount"
          >
            ارسال
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="createCompanyDialog" max-width="600">
      <v-card>
        <v-card-title>
          ساخت کسب‌وکار برای {{ selectedUser.fullname }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="نام شرکت"
                v-model="createCompanyForm.company_name"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                label="نام سال مالی"
                v-model="createCompanyForm.financial_year.name"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="سیستم انبار"
                v-model="createCompanyForm.financial_year.warehouse_system"
                :items="warehouseSystemOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="پکیج"
                v-model="createCompanyForm.package"
                :items="packageOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="6">
              <date label="تاریخ انقضا (خالی = دائمی)" v-model="createCompanyForm.expire_at" :default="false" :clearable="true" type="date" />
              
            </v-col>
            <v-col cols="12" md="6">
              <date
                label="تاریخ شروع سال مالی"
                v-model="createCompanyForm.financial_year.start"
                type="date"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="6">
              <date
                label="تاریخ پایان سال مالی"
                v-model="createCompanyForm.financial_year.end"
                type="date"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-switch
                label="آزمایشی (Trial)"
                v-model="createCompanyForm.is_trial"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="createCompanyDialog = false">انصراف</v-btn>
          <v-btn color="primary" @click="submitCreateCompany">
            ساخت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserDetail from "@/components/users/UserDetail.vue";

export default {
  name: "UsersList",
  components: { UserDetail },
  data() {
    return {
      filters: {
        username__startswith: null,
        first_name__icontains: null,
        last_name__icontains: null,
        phone__icontains: null,
      },
      selectedSurveyFilters: {
        survey_team_size: [],
        survey_accounting_familiarity: [],
        survey_registration_goal: [],
        survey_features_used: [],
        survey_current_accounting: [],
        survey_challenges: [],
      },
      activeFilters: {
        username__startswith: null,
        first_name__icontains: null,
        last_name__icontains: null,
        phone__icontains: null,
      },
      showSurveyFilters: false,
      dialog: false,
      userId: null,
      datatableKey: 0,
      
      teamSizeOptions: [
        "1 تا 5 نفر",
        "6 تا 10 نفر", 
        "11 تا 30 نفر",
        "بیش از 30 نفر"
      ],
      accountingFamiliarityOptions: [
        "آشنایی ندارم",
        "کم", 
        "متوسط",
        "حرفه ای هستم"
      ],
      registrationGoalOptions: [
        "صرفاً برای آشنایی اولیه و بررسی امکانات ثبت‌نام کرده‌ام",
        "در حال بررسی گزینه‌های مختلف برای انتخاب نرم‌افزار حسابداری مناسب هستم", 
        "تصمیم دارم استفاده از نرم‌افزار را در همین هفته آغاز کنم"
      ],
      featuresUsedOptions: [
        "ثبت فاکتور",
        "ثبت هزینه‌ها",
        "مدیریت حقوق و دستمزد", 
        "مدیریت دریافت ها و پرداخت ها",
        "تهیه انواع گزارش‌های مالی (ترازنامه، سود و زیان و…)",
        "مدیریت موجودی و انبار"
      ],
      currentAccountingOptions: [
        "اکسل / گوگل شیت",
        "نرم‌افزار های ویندوزی", 
        "نرم‌افزار های ابری دیگر",
        "سنتی و کاغذی",
        "سایر"
      ],
      challengesOptions: [
        "تأخیر در صدور یا دریافت فاکتور",
        "بی‌نظمی در رسیدها و اسناد",
        "ورود دستی و زمان‌بر داده‌ها", 
        "دشواری در تهیه گزارش‌های تحلیلی",
        "کمبود دسترسی به داده‌های لحظه‌ای",
        "نگرانی‌های امنیت داده",
        "ابهام در قوانین مالیاتی"
      ],
      discountDialog: false,
      selectedUser: {
        id: null,
        fullname: "",
        phone: "",
      },
      discountForm: {
        price_percent: null,
        discount_code: "",
      },
      createCompanyDialog: false,
      createCompanyForm: {
        user_id: null,
        company_name: "",
        needs_accountant: false,
        package: "ONE",
        is_trial: false,
        expire_at: null,
        financial_year: {
          name: "",
          start: null,
          end: null,
          warehouse_system: "d",
        },
      },
      warehouseSystemOptions: [
        { text: "دائمی", value: "d" },
        { text: "ادواری", value: "a" },
      ],
      packageOptions: [
        { text: "پکیج یک (ONE)", value: "ONE" },
        { text: "پکیج دو (TWO)", value: "TWO" },
        { text: "پکیج سه (THREE)", value: "THREE" },
        { text: "پکیج چهار (FOUR)", value: "FOUR" },
      ],
    };
  },
  computed: {
    url() {
      return "sobhanAdmin/usersList";
    },
    title() {
      return "لیست کاربران";
    },
    headers() {
      return [
        {
          text: "آیدی",
          value: "id",
          filterable: false,
        },
        {
          text: "نام",
          value: "first_name",
          filterable: false,
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
          filterable: false,
        },
        {
          text: "نام کاربری",
          value: "username",
          filterable: false,
        },
        {
          text: "شماره تلفن",
          value: "phone",
          filterable: false,
        },
        {
          text: "تاریخ عضویت",
          value: "created_at",
          filterable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[0];
          },
        },
        {
          text: "ساعت عضویت",
          value: "time",
          filterable: false,
          sortable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[1];
          },
        },
        {
          text: "اطلاعات",
          value: "survey",
          filterable: false,
        },
        {
          text: "عملیات",
          value: "actions",
          filterable: false,
          sortable: false,
        },
      ];
    },
  },
  watch: {
    filters: {
      handler(newVal) {
        this.updateActiveFilters();
      },
      deep: true
    }
  },
  methods: {
    handleRowClick(row) {
      this.userId = row.id;
      this.dialog = true;
    },
    openDiscountDialog(user) {
      this.selectedUser = {
        id: user.id,
        fullname: `${user.first_name} ${user.last_name}`,
        phone: user.phone,
      };

      this.discountForm = {
        price_percent: null,
        discount_code: "",
      };

      this.discountDialog = true;
    },

    getSurveySummary(survey) {
      if (!survey || !survey.length) return 'بدون اطلاعات';
      
      const firstAnswer = survey[0].answer;
      if (Array.isArray(firstAnswer)) {
        return `${firstAnswer.length} مورد انتخاب شده`;
      }
      return firstAnswer || 'بدون پاسخ';
    },
    
    clearSurveyFilters() {
      this.selectedSurveyFilters = {
        survey_team_size: [],
        survey_accounting_familiarity: [],
        survey_registration_goal: [],
        survey_features_used: [],
        survey_current_accounting: [],
        survey_challenges: [],
      };
      this.updateActiveFilters();
    },
    
    applySurveyFilters() {
      this.updateActiveFilters();
      this.datatableKey += 1;
    },
    
    updateActiveFilters() {
      this.activeFilters = {
        ...this.filters,
        ...this.getSurveyFilterParams()
      };
    },
    
    getSurveyFilterParams() {
      const params = {};
      
      Object.keys(this.selectedSurveyFilters).forEach(key => {
        if (this.selectedSurveyFilters[key] && this.selectedSurveyFilters[key].length > 0) {
          params[key] = this.selectedSurveyFilters[key].join(',');
        }
      });
      
      return params;
    },

    sendDiscount() {
      if (!this.discountForm.price_percent || !this.discountForm.discount_code) {
        this.errorNotify("همه فیلدها را پر کنید");
        return;
      }

      this.request({
        url: this.endpoint("sobhanAdmin/sms/discount/"),
        method: "post",
        data: {
          phone: this.selectedUser.phone,
          fullname: this.selectedUser.fullname,
          price_percent: this.discountForm.price_percent,
          discount_code: this.discountForm.discount_code,
        },
        success: () => {
          this.successNotify("پیامک با موفقیت ارسال شد");
          this.discountDialog = false;
        },
      });
    },
    openCreateCompanyDialog(user) {
      this.selectedUser = {
        id: user.id,
        fullname: `${user.first_name} ${user.last_name}`,
        phone: user.phone,
      };

      this.createCompanyForm = {
        user_id: user.id,
        company_name: "",
        needs_accountant: false,
        package: "ONE",
        is_trial: false,
        expire_at: null,
        financial_year: {
          name: "",
          warehouse_system: "DAEMI",
        },
      };

      this.createCompanyDialog = true;
    },

    submitCreateCompany() {
      if (!this.createCompanyForm.company_name || !this.createCompanyForm.financial_year.name) {
        this.errorNotify("نام شرکت و نام سال مالی الزامی است");
        return;
      }


      this.request({
        url: this.endpoint("sobhanAdmin/create-company/"),
        method: "post",
        data: this.createCompanyForm,
        success: (data) => {
          this.successNotify("کسب‌وکار با موفقیت ساخته شد");
          this.createCompanyDialog = false;
          this.$refs.datatable.getDataFromApi()
        },
      });
    },
  },
  mounted() {
    this.updateActiveFilters();
  }
};
</script>

<style scoped lang="scss"></style>
